import { LoginMethodType } from 'Lib/constant';

const authServiceMap = { [LoginMethodType.HOSTED_KEYCLOAK]: async () => (await import('@tassat/authentication')).keycloakService };

export default authServiceMap;